import React, { memo } from 'react';
import clsx from 'clsx';
import { CheckCircle2, Clock, History, Settings2 } from 'lucide-react';
import {
  CONNECTION_STATUS,
  CONNECTION_STATUS_LABELS,
} from '../../../../../features/ecommerces/ecommercesPlatforms';

const STYLES = {
  [CONNECTION_STATUS.CONNECTED]: 'bg-ninja-greenLight dark:bg-ninja-green/20 text-ninja-green border-ninja-green/20',
  [CONNECTION_STATUS.PENDING]: 'bg-orange-100 dark:bg-orange-900/30 text-orange-600 dark:text-orange-400 border-orange-500/20',
  [CONNECTION_STATUS.LEGACY]: 'bg-ninja-gray dark:bg-[#2d2d2d] text-text-secondary border-border',
  [CONNECTION_STATUS.CONFIGURED]: 'bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 border-blue-500/20',
};

const ICONS = {
  [CONNECTION_STATUS.CONNECTED]: CheckCircle2,
  [CONNECTION_STATUS.PENDING]: Clock,
  [CONNECTION_STATUS.LEGACY]: History,
  [CONNECTION_STATUS.CONFIGURED]: Settings2,
};

/** How far an integration got; see `getConnectionStatus`. */
const EcommerceStatusBadge = ({ status }) => {
  const Icon = ICONS[status] || Settings2;
  return (
    <span
      data-testid="ecommerce-status"
      data-status={status}
      className={clsx(
        'inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold border whitespace-nowrap',
        STYLES[status]
      )}
    >
      <Icon size={12} />
      {CONNECTION_STATUS_LABELS[status]}
    </span>
  );
};

export default memo(EcommerceStatusBadge);
